<template>
  <section class="Haut text-moyen">
    <div class="Fiche__header">
      <div class="block tl">
        <span class="text-light">Procédure </span>
        <span class="text-reg">{{ mapNames(p.procedures) }}</span>
      </div>
      <div class="block tc">
        <span class="text-reg">{{ p.city }} ({{ p.zipcode.slice(0, 2) }})</span>
      </div>
      <div class="block tr">
        <span class="text-light" v-show="p.missions.length > 0">
          {{ "Mission" | plural(p.missions) }}&nbsp;</span
        ><span class="text-reg">{{ mapNames(p.missions) }}</span>
      </div>
    </div>
  </section>
</template>
<script>
import { mapNames } from "../../../../../util/func";

export default {
  name: "haut-fiche-a3-droite",
  props: {
    p: { type: Object }
  },
  methods: {
    mapNames
  }
};
</script>
